import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useTrackPageView } from '../helpers/trackingHelpers';
import { AppComponentProps, AppRouteComponentMatchParams } from '../typescriptHelpers';
import Space from 'antd/lib/space';
import AppSettingsDescription from './appSettings/AppSettingsDescription';

const AppSettings = (props: AppComponentProps) => {
    const { appIdParam } = useParams<AppRouteComponentMatchParams>();

    useTrackPageView('App Settings', [appIdParam]);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'center',
                flexDirection: 'column',
                paddingBottom: 65,
            }}
        >
            <Space direction="vertical" size={40}>
                <AppSettingsDescription {...props} />
            </Space>
        </div>
    );
};

export default AppSettings;
